import {
    Button,
} from "@mrflark/ui";
import type {
    ReactElement,
    ReactNode,
} from "preact/compat";
import {
    ErrorBoundary as ReactErrorBoundary,
} from "react-error-boundary";
import type {
    FallbackProps,
} from "react-error-boundary";

// react-error-boundary ships react-class typings that don't quite
// satisfy preact/compat's stricter ComponentClass shape. cast here
// once so the JSX usage type-checks
// deno-lint-ignore no-explicit-any
const ErrorBoundary = ReactErrorBoundary as unknown as (
    props: {
        FallbackComponent: (props: FallbackProps) => ReactElement;
        onReset?: () => void;
        children: ReactNode;
    },
) => ReactElement;

const ErrorFallback = ({
    error,
    resetErrorBoundary,
}: FallbackProps): ReactElement => {
    const message = error instanceof Error ? error.message : String(error);

    return (
        <div className="min-h-screen bg-bg-primary flex items-center justify-center p-8">
            <div className="max-w-lg text-center space-y-4">
                <h1 className="text-2xl font-semibold text-text-primary">
                    Something went wrong
                </h1>
                <p className="text-text-secondary">
                    {message}
                </p>
                <div className="flex justify-center gap-3">
                    <Button onClick={resetErrorBoundary}>
                        Try again
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            globalThis.location.href = "/";
                        }}
                    >
                        Go home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export const AppErrorBoundary = ({
    children,
}: { children: ReactNode; }): ReactElement => {
    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => globalThis.location.reload()}
        >
            {children}
        </ErrorBoundary>
    );
};
